/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualListComponent } from './virtual-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SpinnerModule } from '../spinner/spinner.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [VirtualListComponent],
  exports: [VirtualListComponent],
  entryComponents: [VirtualListComponent],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    ScrollingModule,
    ScrollbarModule,
    TranslateModule,
    RouterModule,
    SpinnerModule,
    TooltipModule,
    FormsModule
  ]
})
export class VirtualListModule {}

export { VirtualListComponent };
